module.exports = __webpack_public_path__ + "img/banner-disclaimer.40a3f27f.jpg";